import { FC } from 'react'
import { container } from './styles.css'
import { formatNumber } from '$app/utils'
import { body } from '@genie-fintech/ui/style/typography'
import { themeVars } from '@genie-fintech/ui/style/theme'

const { colors } = themeVars

type Props = {
  label: string
  value: number
}

const GridItem: FC<Props> = ({ label, value }) => {
  return (
    <article className={container}>
      <p className={body.three} style={{ color: colors.neutral[60] }}>
        {label}
      </p>

      <p style={{ fontSize: 40, padding: '16px 0' }}>{formatNumber(value)}</p>
    </article>
  )
}

export default GridItem
